import React from "react";
import "./ConfirmModal.css";

interface ConfirmModalProps {
  title?: string;
  message: string;
  confirmText?: string;
  cancelText?: string;
  onConfirm: () => void;
  onCancel: () => void;
  isLoading?: boolean;
  children?: React.ReactNode;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  title = "Confirm Action",
  message,
  confirmText = "Confirm",
  cancelText = "Cancel",
  onConfirm,
  onCancel,
  isLoading = false,
  children,
}) => {
  return (
    <div className="confirm-overlay" onClick={isLoading ? undefined : onCancel}>
      <div className="confirm-modal" onClick={(e) => e.stopPropagation()}>
        <button className="confirm-close-btn" onClick={onCancel} aria-label="Close" disabled={isLoading}>×</button>
        <div className="confirm-body">
          <div className="confirm-icon">
            <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
              <circle cx="12" cy="12" r="10"/>
              <line x1="12" y1="8" x2="12" y2="12"/>
              <line x1="12" y1="16" x2="12.01" y2="16"/>
            </svg>
          </div>
          {title && <p className="confirm-title">{title}</p>}
          <p className="confirm-message">{message}</p>
          {children && <div className="confirm-extra">{children}</div>}
          <div className="confirm-actions">
            <button className="cancel-btn" onClick={onCancel} disabled={isLoading}>{cancelText}</button>
            <button className="confirm-btn" onClick={onConfirm} disabled={isLoading}>
              {isLoading ? "Processing..." : confirmText}
            </button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default ConfirmModal;
